<template>
  <navbar-component />
  <div class="flex flex-grow">
    <!-- Overlay for mobile -->
    <div
      v-if="isSidebarOpened"
      class="fixed inset-0 bg-black/50 z-10 lg:hidden"
      @click="useUIStore().toggleSidebar"
    ></div>
    <aside :class="['transition-all duration-300', { 'w-0 overflow-hidden': !isSidebarOpened }]">
      <sidebar-component
        ref="sidebar"
        class="absolute lg:relative h-full z-20 lg:z-0 w-64"
        v-if="isSidebarOpened"
      />
    </aside>
    <main
      class="flex-grow bg-gray-200 p-4 overflow-y-auto relative flex flex-col justify-between transition-all duration-300"
    >
      <div class="flex-grow flex flex-col">
        <RouterView />
      </div>
      <footer class="text-right text-gray-500 mt-4 text-sm">
        Copyright © {{ romanYear }} Rotekinfo Div TIK Polri. All rights
        reserved. {{ version }}
      </footer>
    </main>
  </div>
  <teleport to="body">
    <component
      :is="selectedModal"
      v-if="isModalOpened"
      @close="closeModal"
    ></component>
  </teleport>
</template>

<script setup>
import { version } from "/package.json";
import SidebarComponent from "@/components/layout/SidebarComponent.vue";
import NavbarComponent from "@/components/layout/NavbarComponent.vue";
import ChangeNik from "../widget/modals/ChangeNik.vue";

import { useUIStore } from "../../stores/ui";
import useAuthStore from "@/stores/auth";

import { onMounted, onUnmounted, ref, provide } from "vue";
import { storeToRefs } from "pinia";

import useModal from "../../helper/hooks/useModal";
const [isModalOpened, selectedModal, openModal, closeModal] = useModal();

const sidebar = ref(null);
provide("sidebar", sidebar);

// Roman Numerals Converter
function convertToRoman(year) {
  if (typeof year !== "number" || year < 1 || year > 3999) {
    return "Invalid year";
  }

  const romanNumerals = {
    M: 1000,
    CM: 900,
    D: 500,
    CD: 400,
    C: 100,
    XC: 90,
    L: 50,
    XL: 40,
    X: 10,
    IX: 9,
    V: 5,
    IV: 4,
    I: 1,
  };

  let result = "";

  for (let numeral in romanNumerals) {
    while (year >= romanNumerals[numeral]) {
      result += numeral;
      year -= romanNumerals[numeral];
    }
  }

  return result;
}

const date = new Date();
const year = date.getFullYear();
const romanYear = ref(convertToRoman(year));

function onScreenResize() {
  window.addEventListener("resize", () => {
    setSidebarOpened();
  });
}

const { isSidebarOpened } = storeToRefs(useUIStore());
function setSidebarOpened() {
  if (window.innerWidth >= 1024) {
    isSidebarOpened.value = true;
  }
}

onMounted(() => {
  setSidebarOpened();
  onScreenResize();
  if (!!useAuthStore().user.nik == false) {
    openModal(ChangeNik);
  }
});

onUnmounted(() => {
  window.removeEventListener("resize", onScreenResize);
});
</script>
